import React from 'react';
import { getDeviationType } from '../_helpers';
import { DeviationTypes } from '../../types/deviation';
import LiteratureContent from './Literature';
import JournalContent from './Journal';
import TierContent from './Tier';
const TextualContent = (props)=>{
    const deviationType = getDeviationType(props.deviation);
    switch(deviationType){
        case DeviationTypes.LITERATURE:
            return /*#__PURE__*/ React.createElement(LiteratureContent, props);
        case DeviationTypes.JOURNAL:
            return /*#__PURE__*/ React.createElement(JournalContent, props);
        case DeviationTypes.TIER:
            return /*#__PURE__*/ React.createElement(TierContent, props);
        default:
    }
    return null;
};
TextualContent.displayName = 'TextualContent';
export default TextualContent;

//# sourceMappingURL=TextualContent.js.map